const locale = {
  APPLICATIONS: 'Приложения',
  TheRegistry: 'Журнал записи',
  ThePatients: "Пациенты",
  WaitingList: "Лист ожидания",
  Telephony: "Телефония",
  Doctors: "Врачи",
  WorkingHours: "Рабочие часы",
  Access: "Доступ",
  Testimonials: "Отзывы",
  Services: "Услуги",
  Resources: "Ресурсы",
  EmailSMS: "Email и SMS",
  AutoNotifications: "Авто уведомления",
  MailOut: "Рассылка",
  Balance: "Баланс",
  MessageHistory: "История сообщений",
  Analytics: "Аналитика",
  GeneralAnalytics: "Общая аналитика",
  Employees: "Сотрудники",
  Employee: "Сотрудник",
  BlackBox: "Черный ящик",
  MaterialAccounting: "Учет материалов",
  Products: "Товары",
  OrderProducts: "Заказные товары",
  Categories: "Категории",
  Suppliers: "Бренды",
  Suppliers: "Поставщики",
  FlowOfGoods: "Движение товаров",
  Storages: "Склады",
  Inventory: "Инвентаризация",
  Payroll: "Расчет зарплат",
  SalarySettings: "Настройки зарплат",
  OnlineBooking: "Онлайн-запись",
  CompanysSettings: "Настройки компании",
  Payment: "Оплата",
  SignIn: 'Войти',
  SignedOut: 'Вышел',
  UserName: "Имя пользователя",
  Password: 'Пароль',
  SignOut: 'Выход',
  Branch: 'Филиал',
  Company: 'Компания',
  Save: 'Сохранить',
  AboutCompany: 'О компании',
  TheTitleOfTheCompany: 'Заголовок компании',
  BankingDetails: 'Банковские реквизиты',
  EnterTheBankingDetails: 'Введите реквизиты',
  TheNameOfTheCompany: 'Название компании',
  Activity: 'Вид деятельности',
  PhoneNumberOwners: 'Номер телефона (Владельца)',
  TheCompanysAddress: 'Адрес компании',
  City: 'Город',
  SessionHistoryRetentionPeriod: 'Срок хранения истории визитов',
  SettingsAreSaved: 'Настройки сохранены',
  PhoneNumber: 'Мобильный телефон',
  EmailAddress: 'Email адрес',
  CategoryPermission: 'Категория доступа',
  Function: 'Функции',
  Jurnal: 'Журнал',
  Online: 'Онлайн',
  NewAdministrator: 'Новый администратор',
  NewDoctor: 'Новый врач',
  SettingsProfile: 'Настройка профиля',
  Name: 'Имя',
  Surname: 'Фамилия',
  EmailProgramAccess: 'Электронная почта (Доступ к программе)',
  Dostup: 'Доступ',
  AvailableTimeForOnlineRegistration: 'Доступное время для онлайн-записи',
  Phone: 'Tелефон',
  Access: 'Доступ',
  Photo: 'Фотография',
  BeginningOfWork: 'Начало работы',
  January: 'Январь',
  February: 'Февраль',
  March: 'Март',
  April: 'Апрель',
  May: 'Mай',
  June: 'Июнь',
  July: 'Июль',
  August: 'Август',
  September: 'Сентябрь',
  October: 'Октябрь',
  November: 'Ноябрь',
  December: 'Декабрь',
  Monday: 'Понедельник',
  Tuesday: 'Вторник',
  Wednesday: 'Среда',
  Thursday: 'Четверг',
  Friday: 'Пятница',
  Saturday: 'Суббота',
  Sunday: 'Воскресенье',
  Mon: 'Пн',
  Tues: 'Вт',
  Wed: 'Ср',
  Thur: 'Чт',
  Fri: 'Пт',
  Sat: 'Сб',
  Sun: 'Вс',
  TODAY: 'Сегодня',
  Description: 'Описание',
  Patients: 'Пациенты',
  Birthday: 'День Рождения',
  Gender: 'Пол',
  Discount: 'Скидка',
  EntriesInmonths53: '5+ записей за 3 месяца',
  EntriesInmonths23: '2+ записей за 3 месяца',
  HaventRegis3: 'не записывались более 3 месяцев',
  HaventRegis6: 'не записывались более 6 месяцев',
  NotReg: 'нет записей',
  InTheLast30days: 'За последние 30 дней',
  CantSignUpOnline: 'не могут записаться онлайн',
  CanceledCO: '% отмены визитов больше выполненных',
  Filtr: 'Фильтры',
  MostActive: 'Наиболее активные',
  Permanent: 'Постоянные',
  NotActive: 'Не активные',
  Missing: 'Пропавшие',
  DidntVisit: 'Не посещали',
  NewClients: 'Новые клиенты',
  BlackList: 'Черный список',
  Problematic: 'Проблемные',
  AllInformation: 'Общая информация',
  CardNumbers: 'Номер карты',
  SurnameD: 'Отчество',
  FamilyCard: 'Семейная карта',
  Boy: 'Мужской',
  Girl: 'Женский',
  GenderSelect: 'Выберите пол',
  Pasport: 'Паспорт',
  TheNote: 'Заметка',
  LegalRepesentative: 'Законный представитель',
  SocialNetwork: 'Соц сети',
  Address: 'Адрес',
  LoyaltyPrograms: 'Программы лояльности',
  Insurance: 'Страхование',
  Newsletters: 'Рассылки',
  AutoNote: 'Авто отзыв',
  NewClient: 'Новые клиент',
  Country: 'Страна',
  Region: 'Область',
  PersonalDiscount: 'Персональная скидка',
  InsuranceCompany: 'Страховая компания',
  NumberPolice: 'Номер полиса',
  NewPatient: 'Новый пациент',
  English: 'Английский',
  Russian: 'Русский',
  Uzbek: 'Узбекский',
  UzbekKril: "Узбекский - Кирил",
  SelectABranch: 'Выбрать филиал',
  SearchClientServicesCreatingVisit: 'Поиск клиента, услуги, создание визита',
  Partner: "Напарник",
  AvailableTimeForOnlineRegistration: "Доступное время для онлайн-записи",
  Specialization: "Специализация",
  Short: "Низкий",
  Average: "Средний",
  Admin: "Админ",
  DeleteEmploye: "Удалить сотрудника?",
  Delete: 'Удалить',
  Cancel: "Отмена",
  SuccessfulSaved: "Успешно сохранено",
  NameN: 'Наименование',
  NameProduct: 'Наименование товара',
  CodeProduct: 'Код товара',
  NominalVolume: 'Номинальный объем',
  Remainder: 'Остаток',
  Reserve: 'Резерв',
  Unit: 'Единица измерения ',
  LowBalanceNotification: 'Уведомление о низком остатке',
  EnableWarehouseControl: 'Включить контроль склада',
  EnableRetailSales: 'Включить продажу в розницу',
  Brend: 'Бренд',
  Brands: 'Бренды',
  Category: 'Категория',
  NameCategory: 'Название категории',
  NewCategory: 'Новая категория',
  EditCategory: 'Редактирование категории',
  DeleteCategory: "Удалить категорию?",
  SearchCategories: 'Поиск категорий',
  Seria: "Серия",
  Serias: "Серии",
  NameSeria: "Название серии",
  NewSeria: "Новая серия",
  EditSeria: "Редактировать серию",
  DeleteSeria: "Удалить серию?",
  SearchSerias: "Поиск серий",
  NameBrands: 'Название бренда',
  NewBrands: 'Новый бренд',
  EditBrands: 'Редактирование бренда',
  DeleteBrands: "Удалить бренд?",
  SearchBrands: 'Поиск брендов',
  NameResources: 'Название ресурса',
  NewResources: 'Новый ресурс',
  EditResources: 'Редактирование ресурса',
  DeleteResources: "Удалить ресурс?",
  SearchResources: 'Поиск ресурсов',
  NewProduct: 'Новый товар',
  Invoice: 'Накладная',
  EditProduct: 'Редактирование товара',
  DeleteProduct: "Удалить товар?",
  SearchProduct: 'Поиск товаров',
  NameSuppliers: 'Поставщик',
  Suppliers: 'Поставщики',
  NewSuppliers: 'Новый поставщик',
  EditSuppliers: 'Редактирование поставщика',
  DeleteSuppliers: "Удалить поставщика?",
  SearchSuppliers: 'Поиск поставщика',
  WebSite: "Веб-сайт",
  NameStoreHouses: 'Название склада',
  NewStoreHouses: 'Новый склада',
  EditStoreHouses: 'Редактирование склада',
  DeleteStoreHouses: "Удалить склад?",
  SearchStoreHouses: 'Поиск складов',
  RetailPrice: 'Розничная цена',
  SupplierPrice: 'Цена поставшика',
  DownloadXLS: 'Скачать XLS',
  All: 'Bce',
  From: 'С:',
  To: 'По:',
  Operation: 'Операция',
  WorkingDays: "Рабочих дней:",
  WorkingHours: "Рабочих часов:",
  HoursForServices: "Часов на услуги:",
  ServicesCarriedOut: "Услуг проведено:",
  AmountOfServices: "Сумма услуг:",
  ProductsSold: "Товаров продано:",
  AmountOfGoods: "Сумма товаров:",
  EmployeeIncome: "Доход сотрудника:",
  CompanyRevenue: "Выручка компании:",
  StartTime: "Время начала",
  ServiceTime: "Время услуги",
  Service: "Услуга",
  OfTheService: "% от услуги",
  Product: "Товар",
  OfTheProduct: "% от товара",
  IncomeEmployees: "Доход Сотруд.",
  CompanyRevenue: "Выручка компании",
  ServicesProvided: "Услуг оказано:",
  ItemsSold: "Продано товаров: ",
  SalarySettings: 'Настройки зарплаты',
  SelectingABet: "Выбор ставки",
  MonthlySalary: "Оклад за месяц",
  GuaranteedSalary: "Гарантированный оклад",
  PercentageOnSales: "Проценты от реализации",
  Rates: "ставки",
  Hours: "часов",
  EnterCategoryName: "Введите название категории",
  ES1: "SMS уведомления",
  ES2: "(уведомления отключены. Недостаточный баланс)",
  ES3: "Авто уведомления (об успешной записи, напоминании о визите, удалении записи, переносе записи)",
  ES4: "Уведомления при записи",
  ES5: "Уведомления при переносе визита",
  ES6: "Интервал напоминаний о предстоящем визите",
  ES7: "Отправлять за день до:",
  ES8: "Уведомить при балансе SMS и Email ниже:",
  ES9: "Постарайтесь избегать записи клиентов в журнал в позднее время, т.к. клиенты получают моментальные sms о записи",
  ES10: "Email уведомления",
  ES11: "Авто уведомления (об успешной записи, напоминании о визите, удалении записи, переносе записи)",
  ES12: "Уведомления при удалении визита",
  ES13: "Напоминания о визитах",
  ES14: "Ссылка на визит в СМС",
  ES15: "Наименование услуги в СМС",
  ES16: "Опция подтверждения новых клиентов",
  ES17: "Sms авто отзыв",
  ES18: "Email авто отзыв",
  before: 'до',
  TurnOff: "Выключено",
  EL1: "SMS рассылка",
  EL2: "Количество смс:",
  EL3: "количество символов:",
  EL4: "Введите текст",
  EL5: "Выбор получателя",
  EL6: "Все клиенты",
  EL7: "Все сотрудники",
  EL8: "Создать рассылку",
  EB1: "Количество SMS:",
  EB2: "Количество Email:",
  EB3: "Пополнить баланс",
  EH1: "На номер",
  Text: "Текст",
  EH2: "Кол-во СМС",
  EHNO: "Ресурсы - это оборудование, помещения, устройства, которые используются при оказании определенных услуг и не могут быть заняты одновременно разными сотрудниками. После создания ресурса, активируйте его в требуемых услугах.",
  Resources: "Ресурсы",
  Date: "Дата",
  NewServices: 'Новая услуга',
  DeleteGroups: "Удалить группу услуг?",
  DeleteGroupsInfo: "Данное действие может привести к удалению визитов в журнале записи, проверьте и сохраните визиты, если они есть.",
  NewEntry: "Новая запись",
  Entry: "Запись ",
  min: "мин",
  Beginning: "Начало",
  Duration: "Длительность",
  OneTimeDiscount: "Однораз. скидка",
  Executor: "Исполнитель",
  ActualPrice: "Фактич. цена",
  AddAService: "Добавить услугу",
  AddHelpers: "Добавить помощников",
  AddingAPatient: "Добавление пациента",
  Telefon: "Телефон",
  AllAmount: "Общая сумма",
  Day: "День",
  Month: "Месяц",
  Year: "Год",
  Profile: "Профиль",
  VisitHistory: "История визитов",
  MedCard: "Мед. карта",
  VisitAmount: "Сумма визитов",
  MiddleCheck: "Средний чек",
  Canceled: "Отменено",
  Done: "Выполнено",
  VisitAll: "Всего визитов",
  Price: "Цена",
  MinimalBudget: "Минимальный бюджет",
  FinanceAnal: "Финансовая аналитика",
  TotalRecords: "Всего записей",
  OnlineRecords: "Онлайн записей",
  JurnalRecords: "Записей в журнал",
  SinceYes: "со вчера",
  NewPatients: "Новые пациенты",
  RegularPatients: "Постоянные пациенты",
  NoPatients: "Без пациентов",
  PatientsNotCome: "Пациенты не пришли",
  NotCatgoryService: "Если в категории есть услуги, она не будет удалена.",
  NameService: "Название услуги",
  DetailsServices: "Детали услуги",
  SettingsService: "Настройки услуги",
  LocalCurrency: "Местная валюта",
  Amountto: "Цена от",
  AmountFrom: "Цена до",
  AmountProduct: "Стоимость товара (опция)",
  Details: "Детали",
  EditServices: "Редактирование услуги",
  DeleteServices: "Удалить услугу?",
  SearchServices: "Введите название услуги",
  Owner: "Владелец",
  LichCalendar: "Личный календарь",
  Shop: "Магазин",
  stock: "склад",
  AddSales: "Добавить продажи",
  HAddSR: "Добавление чека продажи",
  Buyer: "Покупатель",
  Back: "назад",
  Code: "Код",
  Status: "Статус",
  OrderPrice: "Сумма заказа",
  Instalment: "Рассрочка",
  NameSubcategory: 'Название подкатегории',
  NewSubcategory: 'Новая подкатегория',
  EditSubcategory: 'Редактирование подкатегории',
  DeleteSubcategory: "Удалить подкатегорию?",
  SearchSubcategories: 'Поиск подкатегорий',
  Subcategories: "Подкатегории",
  Subcategory: "Подкатегория",
  Quantity: 'Количество',
  Add: "Добавить",
  Repair: "Ремонт",
  Order: "Заказ",
  Nomenclature: "Номенклатура",
  Purchase: "Покупка",
  Sales: "Продажи",
  InterBranch: "Интер Филиал",
  NothingAdded: "Ничего не добавлено",
  EditEntry: "Редактировать запись",
  ClientWaiting: "Клиент ждет",
  ClientCome: "Клиент пришел",
  ClientNo: "Клиент не пришел",
  ClientSuccess: "Клиент подтвержден",
  Master: "Мастер",
  Edit: "Редактировать",
  DeleteEntry: "Удалить запись",
  Directorys: "Каталоги",
  Directory: "Каталог",
  NameDirectorys: "Название каталога",
  NewDirectorys: "Новый каталог",
  EditDirectorys: "Редактировать каталог",
  DeleteDirectorys: "Удалить каталог",
  SearchDirectorys: "Поиск каталогов",
  MatrialTypes: "Типы материалов",
  MatrialType: "Тип материала",
  NameMatrialTypes: "Название типа материала",
  NewMatrialTypes: "Новый тип материала",
  EditMatrialTypes: "Редактировать тип материала",
  DeleteMatrialTypes: "Удалить тип материала",
  SearchMatrialTypes: "Поиск типов материалов",
  ExecutorType: "Тип исполнителя",
  NameExecutorTypes: "Название типа исполнителя",
  NewExecutorTypes: "Новый тип исполнителя",
  EditExecutorTypes: "Редактировать тип исполнителя",
  DeleteExecutorTypes: "Удалить тип исполнителя",
  SearchExecutorTypes: "Поиск типов исполнителей",
  ColourType: "Цвет",
  NameColourTypes: "Название цвета",
  NewColourTypes: "Новый цвет",
  EditColourTypes: "Редактировать цвет",
  DeleteColourTypes: "Удалить цвет",
  SearchColourTypes: "Поиск цветов",
  VentilationSize: "Размер вентиляции",
  NameVentilationSizes: "Название размера вентиляции",
  NewVentilationSizes: "Новый размер вентиляции",
  EditVentilationSizes: "Редактировать размер вентиляции",
  DeleteVentilationSizes: "Удалить размер вентиляции",
  SearchVentilationSizes: "Поиск размеров вентиляции",
  Client: "Клиент",
  Report: "Отчет",
  DebitOrderTransact: "Транзакции заказов",
  DebitTotalTransact: "Общие транзакции",
  DebitTransactSummary: "Отчет по товарам",
  ClientName: "Имя клиента",
  Fullname: "Полное имя",
  VentilationType: "Единицы измерения",
  Measure: "Измерение",
  AutoSalary: "Автоматическая зарплата",
  ProductsNo: "Нет товара",
  ProductsAdd: "Добавить товар",
  ListProducts: "Список товаров",
  Amount: "Цена",
  ProductsAmount: "Стоимость услуги",
  Waiting: "Ожидает",
  RowsPerPage: "Строк на странице",
  Consumptions: "Расходы",
  Consumption: "Расход",
  NameConsumptions: "Название расхода",
  NewConsumptions: "Новый расход",
  EditConsumptions: "Редактировать расход",
  DeleteConsumptions: "Удалить расход",
  SearchConsumptions: "Поиск расходов",
  Success: "Успешно",
  Expectations: "Ожидается",
  Vendor: "Поставщик",
  RateAmount: "Скидка",
  Date: "Дата",
  Reset: "Сбросить",
  OptionType: "Вариант",
  NameOptionTypes: "Название варианта",
  NewOptionTypes: "Новый вариант",
  EditOptionTypes: "Редактировать вариант",
  DeleteOptionTypes: "Удалить вариант",
  SearchOptionTypes: "Поиск вариантов",
  TypeType: "Тип",
  NameTypeTypes: "Название типа",
  NewTypeTypes: "Новый тип",
  EditTypeTypes: "Редактировать тип",
  DeleteTypeTypes: "Удалить тип",
  SearchTypeTypes: "Поиск типов",
  SerialType: "Тип серии",
  NameSerialTypes: "Название типа серии",
  NewSerialTypes: "Новый тип серии",
  EditSerialTypes: "Редактировать тип серии",
  DeleteSerialTypes: "Удалить тип серии",
  SearchSerialTypes: "Поиск типов серий",
  Request: "Запросы",
  AddRequest: "Добавить запрос",
  EnterProductName: "Введите название товара",
  NotMandatory: "(Выбор не обязателен!)",
  Settings: "Настройки",
  Today: "Сегодня",
  Previous: "Предыдущий",
  Next: "Следующий",
  Wait: "Не подтверждено",
  Paid: "Оплачено",
  Finance: "Финансы",
  CASH: "Наличные",
  UZCARD: "Uzcard",
  HUMO: "Humo",
  TRANSFER: "Перевод",
  CLICK: "Click",
  SERTIFICAT: "IHMA",
  UZUM_NASIYA: "Узум в кредит",
  Payments: "Платежи",
  Rollback: "Возврат",
  ExpenseType: "Тип расхода",
  NameExpenseTypes: "Название типа расхода",
  NewExpenseTypes: "Новый тип расхода",
  EditExpenseTypes: "Редактировать тип расхода",
  DeleteExpenseTypes: "Удалить тип расхода",
  SearchExpenseTypes: "Поиск типов расходов",
  AmountOfAcceptedOrders: "Количество принятых заказов",
  TotalAmount: "Общая сумма",
  CancelAmount: "Сумма возврата",
  ExpenseAmount: "Сумма расхода",
  Total: "Всего",
  Send: "Отправить",
  Login: "Войти",
  MY_PROFILE: "Мой профиль",
  OldPassword: "Старый пароль",
  NewPassword: "Новый пароль",
  EditPassword: "Изменить пароль",
  ShortName: "Краткое название",
  Loading: "Загружается",
  AddFilial: "Добавить филиал",
  SaveFilial: "Сохранить",
  RECEPTION: "Прием",
  SearchPasient: "Поиск пациента",
  Indicator: "Доход/Расход",
  EmployeeProductivity: "Продуктивность сотрудника",
  VisitCount: "Количество визитов",
  ClientCount: "Количество клиентов",
  TopServices: "Популярные услуги",
  WorkHourse: "Часы работы",
  VisitHourse: "Часы визита",
  EmptyHourse: "Свободные часы",
  New: "Новый",
  Ear_id: "Правый/Левый",
  document_number: "Номер документа",
  shop_id: "ID магазина",
  serial_number: "Номер серии",
  total_reverse_trans_amount: "Сумма возврата",
  total_trans_amount: "Сумма по номенклатуре",
  total_order_amount: "Сумма заказа",
  total_credit_amount: "Сумма кредита",
  FullOrderList: "Список заказов",
  TotalTransactSummary: "Общий отчет",
  YearOfFilial: "Год начала деятельности",
  UnitPrice: "Цена за единицу",
  NEACTIVE: "Неактивный",
  ACTIVE: "Активный",
  SpecializationType: "Специализация",
  NameSpecializationTypes: "Название специализации",
  NewSpecializationTypes: "Новая специализация",
  EditSpecializationTypes: "Редактировать специализацию",
  DeleteSpecializationTypes: "Удалить специализацию",
  SearchSpecializationTypes: "Поиск специализаций",
  PaymentHistory: "История платежей",
  IsDeleteClientOrder: "Извините, запись не может быть удалена, так как платеж уже был произведен!",
  DocumentNumber: "Номер контракта",
  More: "Подробнее",
  Income: "Доход",
  Rollback: "Возврат",
  Debt: "Долг",
  Sold: "Продано",
  Repair: "Ремонт",
  Labaratory: "Лаборатория",
  PHONE_NUMBER_DUBLICATE: "Этот номер уже зарегистрирован, пожалуйста, найдите его по телефону или имени!",
  DescLab: "Описание лаборатории",
  Send: "Отправлено",
  Working: "В процессе",
  Acceptance: "Принятие",
  Ready: "Готово",
  IsDeleteClientOrderPOR: "Извините, запись не может быть удалена, так как есть товары, заказы или ремонт в материальном списке!",
  IsDeleteClientOrderSales: "Извините, запись не может быть удалена, так как есть товары, заказы или ремонт в списке продаж!",
  NotDelete: "Не может быть удалено!",
  SalesHistory: "История продаж",
  SelectDate: "Выберите дату",
  ProductsType: "Тип товара",
  AllPrice: "Общая сумма",
  District: "Район/Город",
  SearchSeria: "Поиск серии",
  Search: "Поиск",
  Sum: "сум",
  CurrencyRate: "Валюта курс",
  CurrencyHistory: "История курса",
  date: "дата",
  AddServices: "Добавить услуги",
  HowDidYouHearAboutUs: "Как вы узнали о нас",
  ForgotPassword: "Забыли пароль?",
  NewEmailPassword: "Новый пароль будет отправлен на этот адрес электронной почты.",
  Materilas: "Материалы",
  ClientHistory: "История клиента",
  ProductNumber: "Номер продукта",
  SorryNoProduct: "Извините, такой продукт не найден",
  Found: "найдено",
  NoOrder: "Нет заказа",
  AddOrder: "Добавить заказ",
  Right: "Правая",
  Left: "Левая",
  OnsideColor: "Внешний цвет",
  InColor: "Внутренний цвет",
  Size: "Размер",
  UsedProducts: "Использованные продукты",
  ProductHistory: "История продукта",
  Too: "до",
  Fromm: "от",
  SuccessfullyCompleted: "Успешно завершено",
  DoYouWantToReturnTheGoods: "Вы хотите вернуть товар?",
  YouAddedThisSeries: "Вы уже добавили эту серию",
  SeriaNumber: "Серийный номер",
  AvailableSerialNumbers: "Доступные серийные номера",
  AvailableQuantity: "Доступное количество",
  FinishedProduct: "Готовая продукция",
  FinishedProductConfirmation: "Подтверждение готовой продукции",
  NotRefundable: "Не подлежит возврату",
  HearingAids: "Слуховые аппараты",
  PersonalHearingAids: "Индивидуальные слуховые аппараты",
  HearingAidParts: "Запчасти для слуховых аппаратов",
  OtherGoods: "Прочие товары",
  Location: "Местоположение",
  NotificationAmount: "Сумма уведомления",
  AvailableItems: "Товары в наличии",
  Transactions: "Транзакции",
  NoProductToRepair: "Нет продукции для ремонта",
  EnterOnlyLatinLetters: "Введите только латинские буквы!",
  Remainder: "Остаток",
  TotalCalculatedAmount: "Общая рассчитанная сумма",
  Conclusion: "Завершение",
  ThankYouLook: "Спасибо! Ждём вас снова.",
  ProductsAboutInfo: "Информация о продуктах",
  ServicesAboutInfo: "Информация об услугах",
  Incomes: "Доходы",
  AboutInfo: "Информация о",
  ServiceWork: "Обслуживание",
  PaymentType: "Тип оплаты",
  User: "Пользователь",
  IncorrectUsernameOrPassword: "Неверное имя пользователя или пароль",
  SendEmail: "Отправлено на электронную почту",
  PaidP: "Платно",
  Series: "С серией",
  WithoutSeries: "Без серии",
  NotPaid: "Не оплачено",
  CustomerMap: "Карта клиентов",
  AutomaticSalaryCalculation: "Автоматический расчёт зарплаты",
  Salary: "Зарплата",
  Retail: "Розница",
  EstimatedSalary: "Расчетная зарплата",
  Bonus: "Бонус",
  Salaries: "Зарплаты",
  YouHaveSignedOut: "Вы вышли из системы!",
  
};

export default locale;
